
import FF_Lazy_Load_Content from './FF_Lazy_Load_Content'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs

/**
 * Module qui gère les formulaires de filtres AJAX qui met à jour le HTML dans l'élément [data-filters-form-results-container].
 */
export default class FF_Filters_Form extends FF_Module {

  /***
   *     # #    # # #####
   *     # ##   # #   #
   *     # # #  # #   #
   *     # #  # # #   #
   *     # #    # #   #
   */
  /**
   * Initialise le module.
   */
  init() {

    // Éléments
    this.elements = {
      ...this.elements,
      filters          : $(this.elements.container).find('.form__field').toArray().filter((filter) => $(filter).attr('name')),
      results_container: $('[data-filters-form-results-container]').get(0),
      spinner          : $('#global-references .spinner').clone().get(0)
    };
    if (!this.elements.results_container) {
      console.error('FF_Filters_Form: L\'élément [data-filters-form-results-container] est manquant dans la page.');
      return;
    }

    // Propriétés
    this.animations = { in: null, out: null };
    this.prevent_empty_values = this.elements.container.hasAttribute('data-filters-form-prevent-empty-values');

    this.filters_values = {};
    this.filters_has_to_be_updated = $(this.elements.filters).filter('select').length !== 0; // On met à jour le HTML des filtres seulement s'il y a des champs de sélection
    this.update_filters_values();

    this.cache = {};
    this.generate_current_cache_key = () => Object.entries(this.filters_values).map(([filter_name, filter_value]) => `${filter_name}:${filter_value}`).join('|');

    // Ajout des écouteurs d'événement pour la soumission du formulaire
    $(this.elements.container)
      .on('click', '.form__input-submit-button', this.submit_search.bind(this))
      .on('change', 'select', this.submit_search.bind(this))
      .on('keydown', 'input', (e) => {
        if (e.key === 'Enter') {
          this.submit_search();
          e.preventDefault();
        }
      });

    // Met les résultats actuels en cache
    this.update_cache();

    // Intialisation des Selectric
    $(this.elements.filters).filter('select').each((select_i, select) => ff_init_selectric_element(select));

  }

  /***
   *      ####  #    # #####  #    # # #####     ####  ######   ##   #####   ####  #    #
   *     #      #    # #    # ##  ## #   #      #      #       #  #  #    # #    # #    #
   *      ####  #    # #####  # ## # #   #       ####  #####  #    # #    # #      ######
   *          # #    # #    # #    # #   #           # #      ###### #####  #      #    #
   *      ####   ####  #####  #    # #   #       ####  ###### #    # #    #  ####  #    #
   */
  /**
   * Soumet le formulaire de recherche et gère le nouveau HTML reçu en AJAX.
   */
  async submit_search() {

    // Bail, si "prevent_empty_values" est à true, et que toutes les valeurs des filtres sont vides
    if (this.prevent_empty_values) {
      const all_values_are_empty = this.elements.filters.every((filter) => !$(filter).val());
      if (all_values_are_empty) {
        return;
      }
    }

    // Valide le nombre de charactères si les attributs min/max-lenght est présent
    const valid_char_limit = this.elements.filters.some((filter) => {
      const filter_min_lenght = parseInt($(filter).attr('minlength')) || 0;
      const filter_max_lenght = parseInt($(filter).attr('maxlength')) || Infinity;
      const filter_input_char = $(filter).val().length;
      return filter_input_char >= filter_min_lenght && filter_input_char <= filter_max_lenght;
    });

    // Gestion du message d'erreur
    const form_input = $(this.elements.filters).get(0);
    const error_message = $(form_input).siblings('.form__input-message').get(0);
    $(error_message).css('opacity', '0');

    // Bail si trop ou pas assez
    if (!valid_char_limit) {
      ff_handle_form_input_error(form_input);
      $(error_message).css('opacity', '1');
      return;
    }

    // Retire le focus sur les filtres
    $(this.elements.filters).trigger('blur');

    // Bail et scroll vers les résultats si la valeur des filtres sont les mêmes
    const filters_values_has_changed = this.elements.filters.some((filter) => {
      const filter_name = $(filter).attr('name');
      return this.filters_values[filter_name] !== $(filter).val();
    });
    if (!filters_values_has_changed) {
      ff_scroll.scroll_to(this.elements.results_container, { offset: vh / -2 + (10 * rem) });
      return;
    }

    // Trouve les instances de FF_Lazy_Load_Content dans le conteneur de résultats et les détruits
    $(this.elements.results_container).find('.lazy-load-content').each((i, lazy_load_content_ele) => {
      if (typeof lazy_load_content_ele.ff_module_instances === 'undefined' || typeof lazy_load_content_ele.ff_module_instances.FF_Lazy_Load_Content === 'undefined') return;
      lazy_load_content_ele.ff_module_instances.FF_Lazy_Load_Content.destroy();
    });

    // Termine l'animation d'entrée si nécéssaire
    if (this.animations.in) {
      this.animations.in.kill();
      this.animations.in = null;
    }

    // Animation de sortie
    gsap.set($(this.elements.results_container).parent(), { cursor: 'progress' });
    gsap.set($(this.elements.results_container).children(), { pointerEvents: 'none' });
    this.animations.out = gsap.to(this.elements.results_container, {
      y         : '5rem',
      opacity   : 0,
      duration  : 0.6,
      ease      : 'power3.in',
      onComplete: () => {
        this.animations.out = null;
      }
    });
    ff_scroll.scroll_to(this.elements.results_container, { offset: vh / -2 + (10 * rem) });

    // Mise à jour des valeurs de filtres
    this.update_filters_values();

    // Mise à jour de l'URL
    const url = new URL(window.location.href);
    Object.entries(this.filters_values).forEach(([filter_name, filter_value]) => {
      if (filter_value) {
        url.searchParams.set(filter_name, filter_value);
      }
      else {
        url.searchParams.delete(filter_name);
      }
    });
    for (const url_search_param_key of url.searchParams.keys()) {
      if (typeof this.filters_values[url_search_param_key] === 'undefined') {
        url.searchParams.delete(url_search_param_key);
      }
    }
    window.history.replaceState({}, '', url);

    // Appel AJAX
    const cache = this.get_cache();
    if (!cache) {
      let is_success = false;
      await Promise.all([
        this.show_spinner(),
        ff_send_ajax_form(this.elements.container, async (data) => {
          if (!data.success) return;
          is_success = true;
          await this.remove_spinner();
          if (this.animations.out) { // Attend la fin des animations avant de procéder
            await this.animations.out;
          }
          this.update_results(data.data.results);
          if (data.data.filters) this.update_filters(data.data.filters);
          this.update_cache(data.data.results, data.data.filters || null);
        })
      ]);
      if (!is_success) {
        this.update_results('');
        this.remove_spinner();
      }
    }
    else {
      if (this.animations.out) { // Attend la fin des animations avant de procéder
        await this.animations.out;
      }
      this.update_results(cache.results);
      this.update_filters(cache.filters);
    }

    // Retire l'état de chargement
    gsap.set($(this.elements.results_container).parent(), { clearProps: 'cursor' });

    // Met à jour les valeurs de filtres (On le refait pour être sûr que les valeurs des filtres qui sont manquant soient à jour)
    this.update_filters_values();

  }

  /***
   *     #    # #####  #####    ##   ##### ######    ###### # #      ##### ###### #####   ####     #    #   ##   #      #    # ######  ####
   *     #    # #    # #    #  #  #    #   #         #      # #        #   #      #    # #         #    #  #  #  #      #    # #      #
   *     #    # #    # #    # #    #   #   #####     #####  # #        #   #####  #    #  ####     #    # #    # #      #    # #####   ####
   *     #    # #####  #    # ######   #   #         #      # #        #   #      #####       #    #    # ###### #      #    # #           #
   *      ####  #      #####  #    #   #   ######    #      # ######   #   ###### #    #  ####       ##   #    # ######  ####  ######  ####
   */
  /**
   * Met à jour les valeurs des filtres.
   */
  update_filters_values() {
    this.elements.filters.forEach((filter) => {
      const filter_name = $(filter).attr('name');
      this.filters_values[filter_name] = $(filter).val();
    });
  }

  /***
   *     #    # #####  #####    ##   ##### ######    ###### # #      ##### ###### #####   ####
   *     #    # #    # #    #  #  #    #   #         #      # #        #   #      #    # #
   *     #    # #    # #    # #    #   #   #####     #####  # #        #   #####  #    #  ####
   *     #    # #####  #    # ######   #   #         #      # #        #   #      #####       #
   *      ####  #      #####  #    #   #   ######    #      # ######   #   ###### #    #  ####
   */
  /**
   * Met à jour les filtres reçu en AJAX après la soumission du formulaire.
   * @param {String} filters HTML des filtres à mettre à jour. Doit être ou doit contenir le formulaire ".filter-forms".
   */
  update_filters(filters) {

    if (!this.filters_has_to_be_updated) {
      return;
    }

    // Bail si le formulaire n'est pas présent dans la string donné
    const $filters_element = $(filters).hasClass('filters-form') ? $(filters) : $(filters).find('.filters-form');
    if (!$filters_element.get(0)) {
      return;
    }

    // Bail si le HTML est le même
    if (this.elements.container.outerHTML == $filters_element.get(0).outerHTML) {
      return;
    }

    // Cancel les propriétés CSS ajoutés par l'animation d'entrée de page
    gsap.set($filters_element.find('.form__input-ctn'), { clearProps: 'all' });

    // Met à jour le HTML
    $(this.elements.container).html($filters_element.html());

    // Met à jour l'objet des éléments de filtres
    this.elements.filters = $(this.elements.container).find('.form__field').toArray().filter((filter) => $(filter).attr('name'));
    $(this.elements.filters).filter('select').each((select_i, select) => ff_init_selectric_element(select));

  }

  /***
   *     #    # #####  #####    ##   ##### ######    #####  ######  ####  #    # #      #####  ####
   *     #    # #    # #    #  #  #    #   #         #    # #      #      #    # #        #   #
   *     #    # #    # #    # #    #   #   #####     #    # #####   ####  #    # #        #    ####
   *     #    # #####  #    # ######   #   #         #####  #           # #    # #        #        #
   *      ####  #      #####  #    #   #   ######    #    # ######  ####   ####  ######   #    ####
   */
  /**
   * Met à jour les résultats reçu en AJAX après la soumission du formulaire.
   * @param {String} results HTML des résultats à mettre à jour.
   */
  update_results(results) {

    // ===============================================================
    // Ajoute les résultat dans un conteneur temporaire pour évaluer sa hauteur afin d'animer la hauteur du conteneur parent
    // ===============================================================
    const temp_div = document.createElement('div');
    $(temp_div).css({
      position     : 'absolute',
      width        : '100%',
      opacity      : 0,
      pointerEvents: 'none'
    }).prependTo(this.elements.results_container).append(results);
    const results_height = $(temp_div).innerHeight();
    temp_div.remove();

    // ===============================================================
    // Met à jour le HTML
    // ===============================================================
    gsap.set(this.elements.results_container, { height: $(this.elements.results_container).innerHeight() });
    $(this.elements.results_container).html(results);
    gsap.set(this.elements.results_container, { y: 0, opacity: 1, pointerEvents: 'none' });
    ScrollTrigger.refresh();

    // Si la hauteur de la page avec les nouveaux résultats est plus petites que la hauteur du viewport, on scroll vers le top de la page
    const page_upcoming_height = $(document).height() - ($(this.elements.results_container).height() - results_height);
    if (page_upcoming_height < vh) {
      ff_scroll.scroll_to(0, { duration: 0.9 });
    }

    // ===============================================================
    // Ré-initialise les instances de FF_Lazy_Load_Content  pour les éléments '.lazy-load-content' présents dans le conteneur de résultats
    // ===============================================================
    $(this.elements.results_container).find('.lazy-load-content').each((i, lazy_load_content_ele) => {
      new FF_Lazy_Load_Content(lazy_load_content_ele); // eslint-disable-line no-new
    });

    // ===============================================================
    // Modifications aux éléments
    // ===============================================================
    ff_update_article_cards_titles_font_size();

    // ===============================================================
    // Animation par type de résultats
    // ===============================================================
    const tl = gsap.timeline({
      onComplete: () => {
        this.animations.in = null;
        gsap.set(this.elements.results_container, { clearProps: 'pointerEvents' });
      }
    });
    this.animations.in = tl;

    const new_height = parseFloat($(this.elements.results_container).css('paddingTop')) + parseFloat($(this.elements.results_container).css('paddingBottom')) + results_height;
    tl.to(this.elements.results_container, {
      height    : new_height,
      duration  : 1.2 + gsap.utils.mapRange(0, 3000, 0, 0.15, new_height),
      ease      : 'power4.inOut',
      clearProps: 'height',
      onComplete: () => ScrollTrigger.refresh()
    });

    // Animation pour appareils limités
    if (limit_animations) {
      tl.fromTo(this.elements.results_container, { opacity: 0 }, { opacity: 1, duration: 1.2, ease: 'custom.inOutSlowOut' }, 0.6);
    }

    // Liste d'auteurs
    else if ($(this.elements.results_container).find('.authors-list').get(0)) {
      tl.add(ff_animations.get_animation('authors-list', $(this.elements.results_container).find('.authors-list').get(0)), 0.6);
    }

    // Liste de collaborateurs
    else if ($(this.elements.results_container).find('.collaborators-list').get(0)) {
      tl.add(ff_animations.get_animation('collaborators-list', $(this.elements.results_container).find('.collaborators-list').get(0)), 0.6);
    }

    // Grille d'articles de la page "Médiathèque"
    else if ($(this.elements.results_container).find('.articles-showcase__articles').get(0)) {
      tl.add(ff_animations.get_animation('articles-showcase', $('.articles-showcase')), 0.6);
    }

    // Grille de cartes de la page de recherche
    else if ($(this.elements.results_container).find('.search-results').get(0)) {
      tl.add(ff_animations.get_animation('search-results', $(this.elements.results_container).find('.search-results')), 0.6);
    }

  }

  /***
   *      ####  #    #  ####  #    #     ####  #####  # #    # #    # ###### #####
   *     #      #    # #    # #    #    #      #    # # ##   # ##   # #      #    #
   *      ####  ###### #    # #    #     ####  #    # # # #  # # #  # #####  #    #
   *          # #    # #    # # ## #         # #####  # #  # # #  # # #      #####
   *      ####  #    #  ####  #    #     ####  #      # #    # #    # ###### #    #
   */
  /**
   * Ajoute, affiche et anime le "spinner" de chargement.
   * @returns {Promise} Promise résolu lorsque l'animation est terminée.
   */
  show_spinner() {
    return new Promise((resolve) => {

      // Ajout du spinner au DOM
      $(this.elements.spinner)
        .css({
          position : 'absolute',
          left     : '50%',
          top      : $(this.elements.results_container).position().top + parseFloat($(this.elements.results_container).css('paddingTop')),
          transform: 'translateX(-50%)',
          zIndex   : 1,
          display  : 'none'
        })
        .insertBefore(this.elements.results_container);

      // Animation
      gsap.fromTo(this.elements.spinner, { scale: 0 }, { scale: 1, duration: 1.3, ease: 'expo.out', delay: 0.5, onComplete: resolve });
      gsap.set(this.elements.spinner, { clearProps: 'display' });

    });
  }

  /***
   *     #####  ###### #    #  ####  #    # ######     ####  #####  # #    # #    # ###### #####
   *     #    # #      ##  ## #    # #    # #         #      #    # # ##   # ##   # #      #    #
   *     #    # #####  # ## # #    # #    # #####      ####  #    # # # #  # # #  # #####  #    #
   *     #####  #      #    # #    # #    # #              # #####  # #  # # #  # # #      #####
   *     #    # ###### #    #  ####    ##   ######     ####  #      # #    # #    # ###### #    #
   */
  /**
   * Retire le spinner de chargement de résultats.
   */
  remove_spinner() {
    return new Promise((resolve) => {
      if (!document.body.contains(this.elements.spinner)) { // Bail si l'élément n'est pas dans le DOM
        resolve();
        return;
      }
      gsap.to(this.elements.spinner, {
        scale     : 0,
        duration  : 0.75,
        ease      : 'power4.in',
        onComplete: () => {
          $(this.elements.spinner).remove();
          resolve();
        }
      });
    });
  }

  /***
   *     #    # #####  #####    ##   ##### ######     ####    ##    ####  #    # ######
   *     #    # #    # #    #  #  #    #   #         #    #  #  #  #    # #    # #
   *     #    # #    # #    # #    #   #   #####     #      #    # #      ###### #####
   *     #    # #####  #    # ######   #   #         #      ###### #      #    # #
   *      ####  #      #####  #    #   #   ######     ####  #    #  ####  #    # ######
   */
  /**
   * Met à jour le cache des résultats et des filtres selon la valeur actuelle des filtres.
   * @param {String} results HTML des résultats à mettre en cache. Optionnel, par défaut, prend le HTML du conteneur des résultats.
   * @param {String} filters HTML des filtres à mettre en cache. Optionnel, par défaut, prend le HTML des filtres.
   */
  update_cache(results = null, filters = null) {
    const cache_key = this.generate_current_cache_key();
    this.cache[cache_key] = {
      results: results || this.elements.results_container.innerHTML,
      filters: this.filters_has_to_be_updated ? filters || this.elements.container.outerHTML : null
    };
  }

  /***
   *      ####  ###### #####     ####    ##    ####  #    # ######
   *     #    # #        #      #    #  #  #  #    # #    # #
   *     #      #####    #      #      #    # #      ###### #####
   *     #  ### #        #      #      ###### #      #    # #
   *      ####  ######   #       ####  #    #  ####  #    # ######
   */
  /**
   * Retourne les résultats et les filtres dans le cache selon la valeur actuelle des filtres.
   * @returns {String|null} Résultats dans le cache selon la valeur actuelle des filtre. Retourne null si la valeur n'est pas présente dans le cache.
   */
  get_cache() {
    const cache_key = this.generate_current_cache_key();
    return typeof this.cache[cache_key] !== 'undefined' ? this.cache[cache_key] : null;
  }

}
